/* eslint-disable no-unsafe-optional-chaining */
import { paginatorData } from '@/components/Table/types/pagination';
import { usePaginator } from '@/modules/orders/hooks/usePaginator';
import { getOrdersService } from '@/services';
import { OrderHistory } from '@/utils';
import { useQuery } from '@tanstack/react-query';
import {useCallback, useEffect} from 'react';

type Props = {
  filter?: boolean;
  query?: string;
  queryFilter?: (data: unknown) => unknown[];
};

export const useOrder = ({ filter, query, queryFilter }: Props) => {
  const { paginator, setPaginator } = usePaginator();
  const queryKeys: string[] = [OrderHistory.ROOT];
  if (query) {
    queryKeys.push(query);
  }
  const { isLoading, data, refetch } = useQuery({
    queryKey: queryKeys,
    queryFn: () => getOrdersService(!!filter, paginator.count, paginator.page),
    select: (body: any) => {
      const newBody = queryFilter?.(body);
      return newBody ?? body;
    }
  });

  const handlePaginator = useCallback(() => {
    setPaginator((prev: paginatorData) => ({
      ...prev,
      page: data?.page?.in ?? 1,
      limit: data?.data?.length ? data?.count ?? 0 : 0,
    }));
  },[data, setPaginator])

  useEffect(() => {
    handlePaginator();
  }, [data, handlePaginator]);

  useEffect(() => {
    refetch();
  }, [filter, refetch]);

  return {
    isLoading,
    data,
    refetch,
    paginator,
    setPaginator,
  };
};
